import API from './API';
import { CONTACT_SERVICE_URL as servicePath } from '../constants/APIconstants';
import { GET, POST, PUT, DELETE } from '../utils/Executer';

class ContactServiceAPI {
  async fetch() {
    return await API.client.execute(GET, servicePath);
  }

  async createContact({ contact }) {
    return await API.client.execute(POST, servicePath, contact);
  }

  async updateContact({ id, contact }) {
    return await API.client.execute(PUT, `${servicePath}${id}`, contact);
  }

  async deleteContact({ id }) {
    return await API.client.execute(DELETE, `${servicePath}${id}`);
  }

  /**
   * Bulk-imports contacts into the organization.
   * @param {Object} params
   * @param {Object[]} params.contacts - Rows to create or update; only the keys present are written.
   * @param {string} params.organizationId
   * @param {boolean} [params.replace] - Also remove every org contact no row matched.
   * @param {boolean} [params.dryRun] - Compute the outcome without writing anything.
   * @returns {Promise<Object>} The Executer result; `data` is `{ created, updated, deleted, errors }`.
   */
  async importContacts({ contacts, organizationId, replace, dryRun }) {
    return await API.client.execute(PUT, `${servicePath}bulk`, {
      contacts,
      organizationId,
      replace,
      dryRun,
    });
  }
}

export default new ContactServiceAPI();
